import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from '../core/services/base-api.service';
import { AppConfigService } from '../core/services/app-config.service';

@Injectable({ providedIn: 'root' })
export class LastRefreshService extends BaseApiService {
    constructor(http: HttpClient, appConfigService: AppConfigService) {
        super(http, appConfigService);
    }

  getLastRefreshTime(): Observable<string> {
    return this.get('master/last-refresh');
  }
} 